import React from 'react';
export function Footer() {
  return <footer className="bg-brand-surface py-8 border-t border-brand-border text-center text-brand-muted text-sm" data-id="element-63">
      <div className="max-w-4xl mx-auto px-4" data-id="element-64">
        <p className="mb-2" data-id="element-65">
          © {new Date().getFullYear()} El Manual del 5 Moderno. Todos los
          derechos reservados.
        </p>
        <p data-id="element-66">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}